import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';

const StrengthOMeter = (props) => {
    let { reqs } = props;

    var count = 0;
    for (var propName in reqs) {
        if (Boolean(reqs[propName])) {
            count++;
        }
    }
    
    return (
        <div className="hrb-pw-som-container">
            <div className={classNames('hrb-pw-som-inner hrb-pw-som-left', {
                'hrb-pw-som-red': count === 2,
                'hrb-pw-som-yellow': (count > 2 && count < 5),
                'hrb-pw-som-green': count >= 5
            })} />
            <div className={classNames('hrb-pw-som-inner', {
                'hrb-pw-som-yellow': (count > 2 && count < 5),
                'hrb-pw-som-green': count >= 5
            })} />
            <div className={classNames('hrb-pw-som-inner hrb-pw-som-right', {
                'hrb-pw-som-green': count >= 5
            })} />
        </div>
    );
}

StrengthOMeter.propTypes = {
    reqs: PropTypes.shape({
        hasCapital: PropTypes.bool.isRequired
    })
};


export default StrengthOMeter;
